<template>
  <div class="fair-root">
    <div class="fair-header">
      <div class="fair-header-main">
        <div class="fair-header-title">
          <img src="@/assets/images/fair/zph-logo.png"/>
          <span style="text-align:left;position: relative;top:5px;width:420px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;display: inline-block;line-height:32px;">
            <span  v-if="isShowSite" v-text="getSiteCity()">济南</span>公共就业招聘<span class="cloud">云平台</span>
          </span>
          <span  v-if="isShowSite" v-on:click="loadSites" class="appCss" v-html="siteName()">济南站</span>
        </div>
        <div class="fair-header-ewm">
          <span class="span-cursor" v-on:click="gotoFairIndex()">首页</span>
          <span class="span-cursor" v-if="!isL" v-on:click="openLogin()">登陆/注册</span>
          <!-- <span class="span-cursor" v-on:click="openAdmin()">管理员登陆</span> -->
          <!-- <span class="span-cursor" v-if="isL && isE" v-on:click="openAttend()">企业订展/报名</span> -->
          <span class="span-cursor" v-if="!isU" v-on:click="openAttend()">企业订展/报名</span>
          <span class="span-cursor" v-on:click="openAboutUs()">关于我们</span>
          <span class="span-cursor" v-text="cinfo" v-on:click="myIndex()" >个人中心</span>
          <div  class="dropdown text-center selector" style="width:35px;float: right;">
            <a class="nav-link leading-none white-link" :data-toggle="isL?'dropdown':''" style="padding:0">
                <img v-if="isL && hid != null && hid !=''" :src="'/api/dfs/file/loadPic?id='+hid"/>
                <img v-else src="@/assets/images/fair/hiturn-tx.gif">
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow " style="width:90px;min-width:90px;right:0px;padding-top:0px;padding-bottom:0px;height:53px;">
              <a class="dropdown-item" v-on:click="handleLogout" style="height: 50px;line-height: 50px;padding-top:0px;padding-bottom:0px;">
                <i class="dropdown-icon mdi  mdi-logout-variant"></i> 退出
              </a>
            </div>
          </div>
          <span v-if="isL" v-text="lInfo" class="qymc"></span>
        </div>
        <div style="clear:both;"></div>
      </div>
    </div>
    <div  v-if="isSite && !isDefaultPage" class="zph-photo">
      <!-- <img src="@/assets/images/fair/zph-photo.gif"/> -->
    </div>
    <router-view class="fair-main-content"></router-view>
    <Footer class="fair-footer"></Footer>
    <div id="interviewModal" class="modal">
      <div style="position:fixed;top:60px; left:50%;margin-left: -325px;" v-if="showInterview">
        <div class="chat-box">
          <div class="chat-header">
            <span
              v-if="($store.getters.userType=='personal')">{{currentTalkSession.uname}}</span>
            <span
              v-if="($store.getters.userType=='enterprise')">{{currentTalkSession.uname}}</span>
            <i class="fa fa-close" v-on:click="closeInterview"></i>
          </div>
          <!--
          <img src="@/assets/images/profile.png" class="send-icon" v-on:click="sendCvs()"
               v-if="$store.getters.userType=='personal'"/>
          <img src="@/assets/images/interview-send.png" class="send-icon" v-on:click="sendInterviews()"
               v-if="$store.getters.userType=='enterprise'"/>
          -->
          <div style="clear:both;"></div>
          <JwChat
            :taleList="list"
            @enter="bindEnter"
            v-model="inputMsg"
            :toolConfig="tool"
            :width="650"
            :height="500"
            style="z-index:999;"
            :scrollType="scrollType">
            <template slot="tools">
              <div style="width:38rem;text-align:right;">
                  <i v-on:click="sendCvs()" v-if="$store.getters.userType=='personal'"  class="fa fa-send-o chat-btn" style="font-size:15px;">&nbsp;发送简历</i>
                  <i v-on:click="sendInterviews()" v-if="$store.getters.userType=='enterprise'"  class="fa fa-send-o chat-btn" style="font-size:15px;">&nbsp;邀请面试</i>
              </div>
            </template>
          </JwChat>
          <input id="file" type="file" style="display:none;" v-on:change="uploadFile">
        </div>
      </div>
    </div>
    <div class="talking-list" v-if="$store.getters.userType!='public'">
      <div class="talking-list-body" v-show="showTalkList">
        <ul class="talk-list-block">
          <li class="talk-item" @click="showInterviewModal(session)" v-for="session in talkSessions"
              v-bind:key="session.id">
            <!--<i :class="session.onlineState==true?'fa fa-user state-icon':'fa fa-user state-icon-not'"></i>-->
            <img v-if="session.onlineState == true && $store.getters.userType=='personal'" src="https://app.hiturnjob.com/images/dh-qy.png" class="state-icon">
            <img v-if="session.onlineState == true && $store.getters.userType=='enterprise'" src="https://app.hiturnjob.com/images/dh-gr.png" class="state-icon">
            <img v-if="session.onlineState == false && $store.getters.userType=='personal'" src="https://app.hiturnjob.com/images/dh-qy-h.png" class="state-icon">
            <img v-if="session.onlineState == false && $store.getters.userType=='enterprise'" src="https://app.hiturnjob.com/images/dh-gr-h.png" class="state-icon">
            <span v-if="$store.getters.userType=='personal'">{{session.uname}}(<i
              v-text="toOpenMessageNum[session.id]==null?0:toOpenMessageNum[session.id]"
              class="message-num"></i>)</span>
            <span
              v-if="$store.getters.userType=='enterprise'">{{session.uname}}(<i
              v-text="toOpenMessageNum[session.id]==null?0:toOpenMessageNum[session.id]"
              class="message-num"></i>)</span>
          </li>
        </ul>
      </div>
      <div  :class="allToOpenMessageNum==0?'talking-list-head':'talking-list-head new-message'"
           @click="showTalkList = !showTalkList"><img src="@/assets/images/sy/icon-talk.png" style="width: 24px;height: 22px;margin:8px;"><span style="display: block;text-align: center;"><span style="width: 16px;display: block;margin: 0px auto;">对话列表︵</span>{{allToOpenMessageNum > 99?'99':allToOpenMessageNum}} <span style="width: 16px;display: block;margin: 0px auto;">︶</span></span></div>
    </div>
    <SendCv ref="sendCv"></SendCv>
    <AddInterview ref="sinter" :cvId="this.targetCvId"></AddInterview>
    <!--<a href="javascript:void(0);" v-if="toPage!='/fair/index' && toPage!=''  && !isDefaultPage" id="back-to-history"
       v-on:click="goHistoryPage()">返回</a>-->

    <div id="siteModal" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content site-content" style="min-height: 280px;">
          <div class="modal-body pd-20">
            <span v-if="$lastSite!=null">您上次登录站点为:{{$lastSite.appName}}</span>
            <h5 style="margin-top: 20px;">站点列表</h5>
            <div style="margin-top: 10px;">
              <ul class="shandong-city">
                <li v-for="item in cities" :key="item.id" @click="changeCity(item.id)" :class="appDistrictCode==item.id?'city-item city-item-select':'city-item'">
                  <span>{{item.value}}</span>
                </li>
              </ul>
            </div>
            <h4 style="clear:both;border-bottom:1px solid #dddddd;padding-top:20px;padding-right:20px;"></h4>
            <div style="margin-top: 20px;">
                <ul class="site-block" v-if="parentApps.length>0">
                  <li v-for="(item,index,key) in parentApps" v-bind:key="item.id">
                    <span class="site-item" v-text="item.appName" v-on:click="changeSite(item)" :class="isAaiblable(item)"></span>
                  </li>
                </ul>
                <div v-if="parentApps.length==0" style="text-align:center;">
                  <img src="@/assets/images/nodata.png" style="height:60px;">
                  <h5 style="margin-top:20px;font-weight:300;">暂未开通，敬请期待</h5>
                </div>
                 <!--<div v-for="(item,index,key) in getParentApp()" v-bind:key="item.id" style="margin-top: 10px;">
                 <span class="site-item" v-text="item.appName" v-on:click="changeSite(item)"
                      :class="isAaiblable(item)"></span> :
                  &nbsp;&nbsp;

                  <span v-for="subItem in getSubApps(item.id)" class="site-item" v-text="subItem.appName" v-on:click="changeSite(subItem)" v-bind:key="subItem.id"
                      :class="isAaiblable(subItem)">
                  </span>
                </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login ref="login" :loginType="1" :loginTitle="'企业登录'"></Login>
    <Attend ref="attend"></Attend>

  </div>
</template>
<script>
    import Footer from "@/components/footer_fair";
    import {getTalkUserList, startTalk, getTalkHistory, onLineState} from '@/api/talk'
    import {parseTime} from '@/utils/datetime'
    import {loginHeader} from '@/api/cache'
    import {upload} from '@/api/common'
    import {getToken} from "@/utils/auth";
    import SendCv from "@/views/fair/commons/select_cv";
    import Attend from "@/views/fair/commons/attend";
    import AddInterview from "@/components/common/job/add_interview_job2";
    import {getAppListAll} from '@/api/app'
    import Login from "@/views/fair/commons/login";
    import {userCanTalk} from '@/api/fair'
    import provice from '@/assets/data/data.js'
    import Toastr from 'toastr2';
    import {removeToken} from "@/utils/auth";
    import {login, logout} from '@/api/user'
    export default {
        name: "fair",
        components: {Footer, SendCv, AddInterview, Login, Attend},
        data() {
            return {
                isShowSite:false,
                isDefaultPage:true,
                num: 0,
                showTalkList: false,
                ws: null,
                list: [],
                inputMsg: '',
                toolConfig: [],
                scrollType:'scroll',
                config: {
                    img: '../image/cover.png',
                    name: 'JwChat',
                    dept: '最简单、最便捷',
                    callback: this.bindCover
                },
                talk: [],
                rightConfig: {},
                tool: {
                    show: ['img','发送简历'],
                    callback: this.toolEvent,
                    showEmoji: false
                },
                targetCvId: "",
                userId: null,
                showInterview: false,
                talkSessions: [],
                currentTalkSession: null,
                toOpenMessageNum: {},
                allToOpenMessageNum: 0,
                fromPage: "",
                toPage: "",
                sites: [],
                currentSite: this.$store.getters.site,
                parentApps:[],
                defSite: "",
                isE: false,
                isU: false,
                isL: false,
                lInfo:"",
                isSite: true,
                cinfo:"个人中心",
                hid:null,
                cities:[],
                provice:provice,
                parentApps:[]
            }
        },
        watch: {
            // 利用watch方法检测路由变化：
            '$route': function (to, from) {
                this.fromPage = from.fullPath;
                this.toPage = to.path;
                console.log(this.fromPage)
                console.log(this.toPage)
                if(this.toPage == "/fair/site"){
                    this.closeHeader(false)
                }else {
                    this.closeHeader(true)
                }
                this.CheckCurrentPage(to.path, from.path);
            }
        },
        created(){
          this.defSite = this.getQueryStr("defSite")
          this.CheckCurrentPage(this.$route.path);
        },
        mounted: function () {
            if (this.$store.getters.userType != 'public') {
                this.initWS()
            }
            this.setDefaultApp()
            this.refreshLogin();
            this.getShanDongCity()
        },
        methods: {
          changeCity:function(id){
              this.appDistrictCode = id
              this.getParentApp()
            },
            getParentApp:function(){
              let parentApps = []
              const sites = this.sites
              for(let i=0;i<sites.length;i++){
                if(sites[i].appDistrictCode==this.appDistrictCode){
                  parentApps.push(sites[i])
                }
              }
              this.parentApps = parentApps
              //return parentApps
            },
            getSubApps:function(id){
              const sites = this.sites
              let subApps = []
              for(let i=0;i<sites.length;i++){
                if(id!=null && sites[i].appId == id){
                  subApps.push(sites[i])
                }
              }
              return subApps
            },
             getShanDongCity:function(){
              const shandong = '37'
              for(let i=0;i<this.provice.length;i++){
                if(this.provice[i].id == shandong){
                  const cities = this.provice[i].children
                  this.cities = cities
                  break
                }
              }
              this.appDistrictCode = this.cities[0].id
            },
            refreshLogin() {
                var ut = this.$store.getters.userType
                if (ut != "public") {
                    this.isL = true;
                    this.loginHeaders();
                    if(this.$route.query.unLogin == "true"){
                        var qu = this.$route.query;
                        var newQuery = {}
                        Object.keys(qu).forEach(function (key) {
                            if(key != "unLogin"){
                                newQuery[key] = qu[key]
                            }
                        })
                        this.$router.push({ query: newQuery });
                    }
                }
                if (ut == "enterprise") {
                    this.isE = true;
                    this.isU = false;
                    const enterpriseInfo = this.$store.getters.enterpriseInfo
                    this.lInfo = enterpriseInfo.enterpriseName
                    this.cinfo = "企业中心"
                }
                if (ut == "personal") {
                    this.isU = true;
                    this.isE = false;
                    const userInfo = this.$store.getters.userInfo
                    this.lInfo = userInfo.username
                    this.cinfo = "个人中心"
                }
            },
            closeHeader(site){
                this.isSite = site
            },
            loginHeaders(){
                loginHeader().then(res=>{
                    this.hid = res.hid;
                })
            },
            gotoFairIndex(){
                this.$router.push({
                    path: `/fair/default`,
                    query: {unLogin:this.$route.query.unLogin}
                })
            },
            openAboutUs(){
                this.$router.push({
                    path: `/fair/aboutUs`,
                    query: {unLogin:this.$route.query.unLogin}
                })
            },
            openAttend(){
              if(this.isL){
                var ut = this.$store.getters.userType
                if(ut == "enterprise"){
                  if(this.isDefaultPage && this.toPage == "/fair/default"){
                      alert('请进入站点，报名对应站点下的招聘会!!')

                  } else{

                      if (this.$store.getters.enterpriseInfo.checkState != 1){
                          alert('企业信息未审核通过不能报名招聘会!!')
                          return
                      }
                      if(this.canOpenAttend == null ){
                          userCanTalk().then(res=>{
                              this.canOpenAttend = res.result;
                              if(this.canOpenAttend){
                                  $('#openAttendDialog').modal('show');
                                  this.$refs.attend.openAttend();
                              }else {
                                  alert('企业信息未审核通过不能报名招聘会!!')
                                  return
                              }
                          })
                      }else {
                          if(this.canOpenAttend){
                              $('#openAttendDialog').modal('show');
                              this.$refs.attend.openAttend();
                          }else {
                              alert('企业信息未审核通过不能报名招聘会!!')
                              return
                          }
                      }
                  }

                }else {
                    // toast.warning('企业用户登录才能使用这个功能哟!!')
                    alert('企业用户登录才能使用这个功能哟!!')
                }
              }
              else{
                    alert('请登陆企业账号进行定展报名!!')
              }
                
            },
            CheckCurrentPage(path, pathForm){
                //判断是否是default页面及延伸页面
                if(path=='/fair/default' || pathForm=='/fair/default' || window.location.hash.indexOf("from=default")>0 || window.location.hash.indexOf("/fair/site")>0){
                    this.isDefaultPage = true;
                }else {
                    this.isDefaultPage = false
                }
                //判断是否显示站点，从default也进入在线招聘详情需要显示
                if((path=='/fair/default' || pathForm=='/fair/default'|| window.location.hash.indexOf("from=default")>0) && window.location.hash.indexOf("/fair/site")<0){
                    this.isShowSite = false;
                }else {
                    this.isShowSite = true
                }
            },
             getQueryStr(name){
                let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                if(window.location.hash.indexOf("?") < 0) return null;
                let r = window.location.hash.split("?")[1].match(reg);
                if (r != null) return decodeURIComponent(r[2]);
                return null;
            },
            isAaiblable: function (item) {

                if (item.available == 0) {
                    return 'not-avaibale';
                }else{
                    if(item.id == this.currentSite.id){
                      return 'site-item-select';
                    }
                }
            },
            myIndex(){
                var href = this.$router.resolve({
                    path: "/home"
                });
                window.open(href.href, '_blank');
            },
            openAdmin(){
              window.open("http://admin.hiturnjob.com");
            },
            openLogin(){
              this.$refs.login.updateCode()
            },
            setDefaultApp() {
                if (this.defSite != null && this.defSite != undefined && this.defSite != "") {
                    getAppListAll({}).then(response => {
                        this.sites = response.apps
                        this.sites.forEach(s => {
                            if (s.id == this.defSite) {
                                this.$store.dispatch("app/changeSite", s)
                                this.currentSite = s
                                var hr = window.location.href
                                var hrs = hr.split("#")
                                var hr1 = hrs[1]

                                    if (this.$store.getters.userType != 'public') {
                                        window.location.href = "/index.html#/fair"
                                    } else {
                                        window.location.href = "http://app.hiturnjob.com/index.html#/fair/index?unLogin=true"
                                    }
                            }
                        })
                    }).catch(err => {
                        console.log(err)
                    })
                }
            },
            changeSite: function (item) {
                if (item.available == 1) {
                    this.$store.dispatch("app/changeSite", item)
                    this.currentSite = item
                    $("#siteModal").modal("hide")

                    var hr = window.location.href
                    var hrs = hr.split("#")
                    var hr1 = hrs[1]
                    if (hr1.startsWith("/fair/index")) {
                        window.location.reload();
                    } else {
                        if (this.$store.getters.userType != 'public') {
                            window.location.href = "/index.html#/fair"
                        } else {
                            window.location.href = "/index.html#/fair/index?unLogin=true"
                        }
                    }
                    //this.$parent.$parent.refreshApp()
                } else {
                    $("#siteModal").modal('hide')
                    alert("站点未开通，敬请期待");
                }
            },
            getSiteCity: function () {

              let  siteName
                if (this.currentSite != null) {
                    siteName=this.currentSite.appName;
                } else {
                    siteName=this.loadSites();
                }
                if(siteName!=null){
                    return siteName.substring(0,siteName.length-1)
                }
                return "";
            },
            siteName: function () {
                if (this.currentSite != null) {
                    return this.currentSite.appName + ' <i class="fa fa-chevron-down" aria-hidden="true"></i>'
                } else {
                    this.loadSites()
                }
            },
            loadSites: function () {
                getAppListAll({}).then(response => {
                    $("#siteModal").modal()
                    this.sites = response.apps
                    console.log(this.currentSite)
                    let currentCode = this.currentSite.appDistrictCode
                    if(currentCode==null){
                      for(let i=0;i<this.sites.length;i++){
                        const site = this.sites[i]
                        if(site.id == this.currentSite.id){
                          currentCode = site.appDistrictCode
                          this.$store.dispatch("app/changeSite", site)
                        }
                      }
                    }
                    this.changeCity(currentCode)
                }).catch(err => {
                    console.log(err)
                })
            },
            loadSites2: function () {
                getAppListAll({}).then(response => {
                    this.sites = response.apps
                    this.sites.forEach(s => {
                        if (s.id == 3) {
                            this.$store.dispatch("app/changeSite", s)
                            this.currentSite = s
                            var hr = window.location.href
                            var hrs = hr.split("#")
                            var hr1 = hrs[1]
                            if (hr1.startsWith("/fair/index")) {
                                window.location.reload();
                            } else {
                                if (this.$store.getters.userType != 'public') {
                                    window.location.href = "/index.html#/fair"
                                } else {
                                    window.location.href = "/index.html#/fair/index?unLogin=true"
                                }
                            }
                        }
                    })
                }).catch(err => {
                    console.log(err)
                })
            },
            goHistoryPage() {
                this.$router.push({
                    path: this.fromPage
                })
            },
            sendCvs() {
                var tid = localStorage.getItem('targetJobId')
                var fid = localStorage.getItem('targetFairId')
                this.$refs.sendCv.getMyCvs(tid, fid);
                this.closeInterview()
                $('#selectSendCv').modal('show');
            },
            sendInterviews() {
                const enterpriseInfo = this.$store.getters.enterpriseInfo
                if (enterpriseInfo != null) {
                    let id = enterpriseInfo.id;
                    this.$refs.sinter.getPubJob(id);
                    this.$refs.sinter.getEntInfo(id);
                }
                var tid = localStorage.getItem('targetCvId')
                this.targetCvId = tid
                this.closeInterview()
                $('#addInterviewByJobModal').modal('show');
            },
            showInterviewModal: function (session) {
                console.log(JSON.stringify(session))
                this.currentTalkSession = session
                const token = getToken()
                const msg = {
                  action:'ensureMessage',
                  sessionId:session.id,
                  accessToken:token
                }
                this.ws.send(JSON.stringify(msg))
                const num = this.toOpenMessageNum[session.id]
                this.toOpenMessageNum[session.id] = 0
                if(num!=null){
                  this.allToOpenMessageNum -= num
                }
                getTalkHistory({id: session.id}).then(response => {
                    const messages = response.messages
                    const list = []
                    for (let i = messages.length - 1; i >= 0; i--) {
                        const message = messages[i];
                        if(message.messageType==0){
                          continue
                        }
                        let content = {
                            'text': {"text": message.messageContent},
                            'img': "http://app.hiturnjob.com/images/hiturn-tx.gif"
                        }
                        if(message.messageDirection == "u1-e"){
                          content['img'] = "http://app.hiturnjob.com/images/dh-gr.png"
                        }else if(message.messageDirection == "e-u1"){
                          content['img'] = "http://app.hiturnjob.com/images/dh-qy.png"
                        }
                        const userType = this.$store.getters.userType
                        if (userType == "personal" && message.messageDirection == "u1-e") {
                            content['mine'] = true
                            content['name'] = this.$store.getters.userInfo.username
                        }
                        if (userType == "personal" && message.messageDirection == "e-u1") {
                            content['mine'] = false
                            content['name'] = this.currentTalkSession.uname
                        }
                        if (userType == "enterprise" && message.messageDirection == "u1-e") {
                            content['mine'] = false
                            content['name'] = this.currentTalkSession.uname
                        }
                        if (userType == "enterprise" && message.messageDirection == "e-u1") {
                            content['mine'] = true
                            content['name'] = this.$store.getters.enterpriseInfo.enterpriseName
                        }
                        let time = new Date(message.sendTime)
                        content['date'] = parseTime(time)
                        list.push(content)
                    }
                    this.list = list
                    $("#interviewModal").modal()
                    this.showInterview = true

                })
            },
            closeInterview: function () {
                $("#interviewModal").modal('hide')
                this.showInterview = false
                this.currentTalkSession = null
            },
            bindEnter: function () {
                if (this.inputMsg != null && this.inputMsg != '') {
                    let name = ''
                    let content = {
                        'text': {"text": this.inputMsg},
                        'img': "http://app.hiturnjob.com/images/hiturn-tx.gif"
                    }
                    const userType = this.$store.getters.userType
                    let direction = "";
                    let to = this.currentTalkSession.uid
                    if (userType == "personal") {
                        direction = "u1-e"
                        content['name'] = this.$store.getters.userInfo.username
                        content['img'] = "http://app.hiturnjob.com/images/dh-gr.png"
                    }
                    if (userType == "enterprise") {
                        direction = "e-u1"
                        content['name'] = this.$store.getters.enterpriseInfo.enterpriseName
                        content['img'] = "http://app.hiturnjob.com/images/dh-qy.png"
                    }
                    let from
                    if(this.$store.getters.userType=='personal'){
                      from = this.$store.getters.userInfo.id
                    }
                    if(this.$store.getters.userType=='enterprise'){
                      from = this.$store.getters.enterpriseInfo.id
                    }
                    const msg = {
                        action: 'p2pTalk',
                        type: 1,
                        direction: direction,
                        to: to,
                        from:from,
                        content: content,
                        sessionId: this.currentTalkSession.id
                    }
                    this.ws.send(JSON.stringify(msg))
                    content['mine'] = true
                    content['date'] = parseTime(new Date())
                    this.list.push(content)
                    
                }
            },
            toolEvent: function (type) {
                if (type == 'file') {
                    document.getElementById('file').click()
                }
                if (type == 'img') {
                    document.getElementById('file').click()

                }
                if (type == 'more') {
                    this.$message.success('您已成功投递简历')
                }
            },
            uploadFile: function () {
                upload('file').then(response => {
                    const path = response.path
                    const contentSrc = "<img data-src='" + path + "' src='" + path + "' style='width:100%;'>"
                    let content = {
                        'text': {"text": contentSrc},
                        'name': this.$store.getters.userInfo.username,
                        'img': "http://app.hiturnjob.com/images/hiturn-tx.gif"
                    }
                    const userType = this.$store.getters.userType
                    let direction = "";
                    let to = ""
                    if (userType == "personal") {
                        direction = "u1-e"
                        to = this.currentTalkSession.uid
                        content['img'] = "http://app.hiturnjob.com/images/dh-gr.png"
                    }
                    if (userType == "enterprise") {
                        direction = "e-u1"
                        to = this.currentTalkSession.uid
                        content['img'] = "http://app.hiturnjob.com/images/dh-qy.png"
                    }
                    let from
                    if(this.$store.getters.userType=='personal'){
                      from = this.$store.getters.userInfo.id
                    }
                    if(this.$store.getters.userType=='enterprise'){
                      from = this.$store.getters.enterpriseInfo.id
                    }
                    const msg = {
                        action: 'p2pTalk',
                        type: 3,
                        direction: direction,
                        to: to,
                        from: from,
                        content: content,
                        sessionId: this.currentTalkSession.id
                    }
                    this.ws.send(JSON.stringify(msg))
                    content['mine'] = true
                    content['date'] = parseTime(new Date())
                    this.list.push(content)
                })
            },
            bindCover: function (play) {
                console.log('user', play)
            },
            initWS: function () {
                const accessToken = getToken()
                const this_ = this
                if ("WebSocket" in window) {
                    // 打开一个 web socket
                    let ws = new WebSocket("wss://admin.hiturnjob.com:10086/talk");
                    ws.onopen = function () {
                        const loginMessage = {
                            action: 'login',
                            accessToken: accessToken
                        }
                        ws.send(JSON.stringify(loginMessage))
                        const loadUnReadMessage = {
                            action: 'loadUnRead',
                            accessToken: accessToken
                        }
                        this_.ws.send(JSON.stringify(loadUnReadMessage))
                    }
                    ws.onmessage = function (evt) {
                        var msg = JSON.parse(evt.data);
                        if(msg.action == 'p2pTalk'){
                          if(msg.otherDevice){
                            const sessionId = msg.sessionId
                            if (this_.currentTalkSession != null && this_.currentTalkSession.id == sessionId) {
                              msg.content['mine'] = true
                              this_.list.push(msg.content)
                            }
                          }else{
                            const sessionId = msg.sessionId
                            if (this_.currentTalkSession != null && this_.currentTalkSession.id == sessionId) {
                                msg['mine'] = false
                                this_.list.push(msg)
                                const token = getToken()
                                const relaseMsg = {
                                  action:'ensureMessage',
                                  sessionId:sessionId,
                                  accessToken:token
                                }
                                this_.ws.send(JSON.stringify(relaseMsg))
                            }
                            if (this_.currentTalkSession == null || this_.currentTalkSession.id != sessionId) {
                                if(this_.toOpenMessageNum[sessionId]!=null){
                                  this_.toOpenMessageNum[sessionId] += 1
                                }else{
                                  this_.toOpenMessageNum[sessionId] = 1
                                }
                                this_.allToOpenMessageNum += 1
                            }
                            for (let i = 0; i < this_.talkSessions.length; i++) {
                                const session = this_.talkSessions[i]
                                if (sessionId == session.id) {
                                    session['sendTime'] = new Date(msg.date.replace(/-/g, '/'))
                                    this_.talkSessions[i] = session
                                    break
                                }
                            }
                            this_.sortSession()
                          }
                        }
                        if(msg.action == 'enterpriseOnLineStateBroadcast'){
                          const toastr = new Toastr()
                          const enterpriseName = msg['enterpriseName']
                          const sessionId = msg['sessionId']
                          for(let i=0;i<this_.talkSessions.length;i++){
                            if(this_.talkSessions[i].id == sessionId){
                              if(msg['onLine']){
                                this_.talkSessions[i].onlineState = true
                              }
                              if(!msg['onLine']){
                                this_.talkSessions[i].onlineState = false
                              }
                              console.log(this_.talkSessions[i].onlineState)
                              break
                            }
                          }
                          if(msg['onLine']){
                            //toastr.info(enterpriseName + '已上线')
                          }
                          if(!msg['onLine']){
                            //toastr.info(enterpriseName + '已离线')
                          }
                          this_.sortSession()
                        }
                        if(msg.action == 'userOnLineStateBroadcast'){
                          const toastr = new Toastr()
                          const user1Name = msg['user1Name']
                          const sessionId = msg['sessionId']
                          for(let i=0;i<this_.talkSessions.length;i++){
                            if(this_.talkSessions[i].id == sessionId){
                             if(msg['onLine']){
                                this_.talkSessions[i].onlineState = true
                              }
                              if(!msg['onLine']){
                                this_.talkSessions[i].onlineState = false
                              }
                              console.log(this_.talkSessions[i].onlineState)
                              break
                            }
                          }
                          if(msg['onLine']){
                            //toastr.info(user1Name + '已上线')
                          }
                          if(!msg['onLine']){
                            //toastr.info(user1Name + '已离线')
                          }
                          this_.sortSession()
                        }
                        if(msg.action == 'updateUserList'){
                          const relationMap = msg['list']
                          const sessions = []
                          for(let key in relationMap){
                            sessions.push(JSON.parse(relationMap[key]))
                          }
                          this_.talkSessions = sessions
                          this_.sortSession()
                        }
                        if(msg.action == 'tok'){

                        }
                    }
                    ws.onclose = function () {
                        const loginMessage = {
                            action: 'logout',
                            accessToken: accessToken
                        }
                        ws.send(JSON.stringify(loginMessage))
                    }
                    this.ws = ws
                    window.onbeforeunload = function () {
                        const logoutMessage = {
                            action: 'logout',
                            accessToken: accessToken
                        }
                        this_.ws.send(JSON.stringify(logoutMessage))
                    }

                    setInterval(() => {
                        const tikMessage = {
                            action: 'tik'
                        }
                        this_.ws.send(JSON.stringify(tikMessage))
                        /*
                        onLineState({}).then(response => {
                            const ids = response.onLineIds
                            for (let i = 0; i < this_.talkSessions.length; i++) {
                                const userType = this_.$store.getters.userType
                                this_.talkSessions[i].onlineState = 0
                                if (userType == "personal") {
                                    if (ids[this_.talkSessions[i].enterpriseId] != null) {
                                        this_.talkSessions[i].onlineState = 1
                                    }
                                }
                                if (userType == "enterprise") {
                                    if (ids[this_.talkSessions[i].user1Id] != null) {
                                        this_.talkSessions[i].onlineState = 1
                                    }
                                }
                            }
                        })*/
                    }, 15000);
                    /*
                    getTalkUserList({}).then(response => {
                        this.talkSessions = response.sessions
                        for (let i = 0; i < this.talkSessions.length; i++) {
                            let session = this.talkSessions[i];
                            this.toOpenMessageNum[session.id] = 0
                        }
                    })*/
                } else {
                    alert("您的浏览器支持 WebSocket!")
                }
            },
            sortSession(){
                let onLineQueue = []
                let offLineQueue = []
                for(let i=0;i<this.talkSessions.length;i++){
                  const session = this.talkSessions[i]
                  if(session.onlineState){
                    if(onLineQueue.length>0){
                      for(let j=0;j<onLineQueue.length;j++){
                        let queueSession = onLineQueue[j]
                        let lastSendTime = new Date(queueSession.lastSendTime)
                        let sessionTime = new Date(session.lastSendTime).getTime()
                        if(sessionTime<lastSendTime){
                          onLineQueue.splice(j,0,session)
                          break
                        }else{
                          if(j==onLineQueue.length-1){
                            onLineQueue.push(session)
                            break
                          }
                        }
                      }
                    }else{
                      onLineQueue.push(session)
                    }
                  }else{
                    if(offLineQueue.length>0){
                      for(let j=0;j<offLineQueue.length;j++){
                        let queueSession = offLineQueue[j]
                        let lastSendTime = new Date(queueSession.lastSendTime).getTime()
                        let sessionTime = new Date(session.lastSendTime).getTime()
                        if(sessionTime<lastSendTime){
                          offLineQueue.splice(j,0,session)
                          break
                        }else{
                          if(j==offLineQueue.length-1){
                            offLineQueue.push(session)
                            break
                          }
                        }
                      }
                    }else{
                      offLineQueue.push(session)
                    }
                  }
                }
                const onlineSort = onLineQueue.reverse()
                const offlineSort = offLineQueue.reverse()
                this.talkSessions = onlineSort.concat(offlineSort)
            },
            startTalk(sessionType, to, sourceId) {
                startTalk({sessionType: sessionType, to: to, sourceType: 'fair', sourceId: sourceId}).then(response => {
                    const accessToken = getToken()
                    const msg = {
                      action:'sendHelloMessage',
                      accessToken:accessToken,
                      sessionId:response.session.id
                    }
                    this.ws.send(JSON.stringify(msg))
                    this.showInterviewModal(response.session)
                })
            },
            handleLogout: function () {
              logout().then(response => {
                  removeToken()
                  window.location.reload();
                }).catch(error => {

                })
            }
        }
    }
</script>
<style scoped>
  .fair-root {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    background-color: #ffffff;
    min-width: 1200px;
  }

  .fair-header {
    /* background-image: linear-gradient(to left, #f7b52d, #769829, #4f6d0b); */
    height: 100px;
    line-height: 100px;
    /* background-color: #8dc21f; */
    background-color: #404c5b;
  }

  .fair-header-main {
    width: 1200px;
    margin: 0 auto;
  }

  .fair-header-title {
    float: left;
    font-size: 32px;
    font-weight: 400;
    color: white;
  }

  .fair-header-title img {
    /* width: 230px; */
    height: 40px;
    margin-top: -5px;
  }

  .fair-header-title span {
    height: 32px;
    top: -5px;
  }

  .fair-header-ewm {
    float: right;
  }

  .fair-header-ewm span{
    color: #ffffff;
    margin-left: 10px;
  }
  .qymc{
    max-width: 98px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    float:right;
  }
  .fair-header-ewm-img{
    width:30px;
    float: right;
  }
  .fair-header-ewm img {
        width: 30px;
    height: 30px;
    border-radius: 50px;
    float: right;
    margin-top: 35px;
    margin-left: 5px;
  }
  .zph-photo{
    /* width:100vw; */
    height: 200px;
    background: url("../assets/images/fair/zph-photo.gif") no-repeat center top;
    background-color: #738daf;
  }
   .zph-photo img{
     width: 100%;
     height: 100%;
    margin-top: -7px;
   }
  .cloud {
    /* color: #FEF35B; */
    color: #ffffff;
    font-weight: 500;
  }

  .fair-main-content {
    min-height: 760px;
    display: inline-block;
  }

  .fair-footer {
    margin-top: 20px;
  }

  .talking-list {
    position: fixed;
    top: 160px;
    right: 0px;
    height: 450px;
  }

  .talking-list-body {
    border: 1px solid #ddd;
    width: 300px;
    height: 100%;
    float: right;
    background: #fff;
    text-align: left;
    overflow-y: scroll;
  }

  .talking-list-head {
    width: 40px;
    /* height: 180px; */
    float: right;
    /* background: #8ab734; */
    background: #d8d8d8;
    /* padding: 8px; */
    margin-top: 100px;
    cursor: pointer;
    border-radius: 5px;
  }

  .talking-list-head span {
    font-size: 16px;
    color: #ffffff;
  }

  .list-header {
    background: #97d1f8;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    font-weight: 400;
  }

  .talk-list-block {
    padding: 10px;
  }

  .talk-list-block li {
    border-bottom: 1px dashed #dddddd;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    padding-left: 5px;
  }

  .talk-list-block li:hover {
    background: #d5e4be;
  }

  .talk-list-block .state-icon {
    font-size: 18px;
    color: #2ca8ff;
    width: 18px;
    height: 18px;
  }

  .talk-list-block span {
    font-size: 14px;
    margin-left: 10px;
  }

  .interview-modal {
    position: absolute;
    margin: 200px auto;
  }

  .web__tools dl {
    display: block !important;
    margin-block-start: 1em !important;
    margin-block-end: 1em !important;
    margin-inline-start: 0px !important;
    margin-inline-end: 0px !important;
  }

  .chat-box {
    width: 650px;
    height: 550px;
    border: 1px solid #dddddd;
    margin: 10px auto;
  }

  .chat-header {
    background: #ffffff;
    height: 50px;
    position: relative;
    box-shadow: 0px 3px 5px #dddddd;
    z-index: 1000;
  }

  .chat-header img {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 10px;
    left: 10px;
  }

  .chat-header span {
    position: absolute;
    top: 15px;
    left: 10px;
    color: #666666;
    font-weight: 400;
  }

  .chat-header i {
    position: absolute;
    right: 10px;
    top: 15px;
    color: #888888;
    font-size: 22px;
    cursor: pointer;
    font-weight: 100;
  }

  .message-num {
    font-size: 14px;
    color: #222222;
    font-weight: 200;
    font-style: normal;
  }

  @keyframes blink {
    from {
      background: #7db919;
    }
    to {
      background: #db6e08;
    }
  }

  @-webkit-keyframes blink {
    from {
      background: #7db919;
    }
    to {
      background: #db6e08;
    }
  }

  .new-message {
    /* animation: blink 1s infinite;
    -moz-animation: blink 1s infinite;
    -webkit-animation: blink 1s infinite; */

    background: #8ab734;
  }

  .talk-list-block .state-icon-not {
    font-size: 18px;
    color: #eeeeee;
  }

  .send-icon {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 60px;
    left: 10px;
    z-index: 9990;
  }

  #back-to-history {
    background: #ffffff;
    border: 1px solid #1da1f8;
    color: #1da1f8;
    padding: 5px 10px;
    position: fixed;
    right: 50%;
    margin-right: -595px;
    top: 200px;
    z-index: 99;
    display: none;
    text-align: center;
    border-radius: 5px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    -o-border-radius: 2px;
    z-index: 999;
    width: 70px;
    background-repeat: no-repeat;
    background-position: center;
    transition: background-color 0.1s linear;
    -moz-transition: background-color 0.1s linear;
    -webkit-transition: background-color 0.1s linear;
    -o-transition: background-color 0.1s linear;
    display: inline;
  }

  #back-to-history:hover {
    background: #1da1f8 !important;
    color: #ffffff !important;
  }

  .appCss {
    position: relative;
    top: 3px;
    padding: 2px 15px 2px 10px;
    color: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 5px;
    font-size: 12px;
    font-style: normal;
    cursor: pointer;
    margin-left: 10px;
  }

  .site-item {
    border: 1px solid #eeeeee;
    border-radius: 5px;
    font-size: 12px;
    font-style: normal;
    padding: 2px 15px 2px 15px;
    margin-right: 15px;
    float: left;
    cursor: pointer;
  }

  .site-item-no {
    font-size: 12px;
    font-style: normal;
    padding: 2px 5px;
    margin-right: 5px;
    float: left;
  }


  .not-avaibale {
    background: #dddddd;
  }

  .span-cursor {
    cursor: pointer;
    display: inline-block;
  }
.site-block{
    display: inline;
  }
  .site-block li{
    float: left;
    margin-bottom:10px;
  }
  .city-item-select{
    font-weight: 500;
    color:#FC5B17
  }
  .site-item-select{
    border: 1px solid #6A8C1F;
    background: #99A519;
    color:#ffffff;
  }
  .shandong-city{
    list-style: none;
    display: inline;
  }
  .shandong-city .city-item{
    margin-right: 20px;
    float: left;
    cursor: pointer;
  }
  .chat-btn{
    margin-left:5px;
    font-size:14px;
    cursor:pointer;
  }
  .chat-btn:hover{
    color:#1da1f8;
  }
  .web__main-text{
    background-color:#f8b62b !important;
  }
  .dropdown-item:hover{
    color:#f8b62b;
    cursor: pointer;
  }
a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus{
    color:#f8b62b
}

</style>



// WEBPACK FOOTER //
// src/layout/fair.vue